import { useTranslation } from 'react-i18next'

import BuildingAnalyticIcons from '@/components/BuildingAnalytics/BuildingAnalyticIcons/BuildingAnalyticIcons'
import { BOOKING_TYPES_ICONS, SERVICE_COLORS } from '@/helpers/constants'

import { ColorField, IconField } from '../../shared/visual-fields'

interface BookingTypeIconFieldProps {
  color: string
}

export const BookingTypeIconField = ({ color }: BookingTypeIconFieldProps) => {
  const { t } = useTranslation(['organisation'])

  return (
    <IconField
      color={color}
      icons={BOOKING_TYPES_ICONS as string[]}
      label={t('organisation:bookingTypes.type.fields.icon.label')}
      renderIcon={(icon) => <BuildingAnalyticIcons name={icon} />}
    />
  )
}

export const BookingTypeColorField = () => {
  const { t } = useTranslation(['organisation'])

  return (
    <ColorField
      colors={SERVICE_COLORS as string[]}
      label={t('organisation:bookingTypes.type.fields.color.label')}
    />
  )
}
